import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
/*
 * 实现功能：在响应拦截器中处理成功请求(200)的暂停与恢复
 * 重新选择实例后，重新发起请求
 */
import { Modal, Table } from "view-design";
export const multipleJs = {
  pendingRequests: {
    originalResponse: "",
    resolve: ""
  },
  row: null,
  axios: null,
  multipleInstances(response, axios) {
    return new Promise(resolve => {
      // 存储原始响应和resolve函数
      this.pendingRequests.originalResponse = response;
      this.pendingRequests.resolve = resolve;
      this.axios = axios;
      this.showModal();
    });
  },
  // 辅助函数：将参数添加到URL
  addParamsToUrl(url, params) {
    const urlObj = new URL(url, window.location.origin);
    Object.entries(params).forEach(([key, value]) => {
      urlObj.searchParams.append(key, value);
    });
    return urlObj.pathname + urlObj.search;
  },
  onSubmit(userParams) {
    let request = this.pendingRequests.originalResponse;
    const config = request.config;
    // 创建新的URL，添加用户参数
    const newUrl = this.addParamsToUrl(config.url, userParams);
    // 创建新的请求配置
    const newConfig = {
      ...config,
      url: newUrl
    };
    // 重新发起请求
    this.pendingRequests.resolve(this.axios(newConfig));
    this.clear();
  },
  clear() {
    this.row = null;
    this.pendingRequests.originalResponse = "";
    this.pendingRequests.resolve = "";
    this.axios = null;
    Modal.remove();
  },
  showModal() {
    const columns = [{
      key: "instanceName"
    }, {
      key: "instanceCode",
      width: 200
    }];
    const data = this.pendingRequests.originalResponse.data.retVal || [];
    if (data.length > 0) {
      data[0]._highlight = true;
      this.row = data[0];
    }
    Modal.confirm({
      width: 800,
      styles: {
        "max-height": "80vh",
        "overflow-y": "auto"
      },
      loading: true,
      render: h => {
        return h("div", [h("div", {
          style: {
            marginBottom: "16px",
            fontSize: "16px",
            fontWeight: "bold"
          }
        }, $t("bwcfal4", "实例选择")), h("div", {
          style: {
            maxHeight: "400px",
            overflowY: "auto"
          }
        }, [h(Table, {
          props: {
            columns,
            data,
            highlightRow: true,
            showHeader: false
          },
          on: {
            "on-current-change": currentRow => {
              this.row = currentRow;
            }
          }
        })])]);
      },
      onOk: () => {
        const params = {
          "gc-instance-code": this.row.instanceCode,
          "gc-instance-url": this.row.appUrl
        };
        this.onSubmit(params);
      },
      onCancel: () => {
        this.clear();
      }
    });
  }
};